var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('ByFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../../assets/order_pending.png"),"alt":"payment"}}),_c('p',[_vm._v("確認支付狀態中...")])])])
}]

export { render, staticRenderFns }